(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('Declined', Declined);

    Declined.$inject = ['$resource'];

    function Declined ($resource) {
        var resourceUrl =  'api/declineds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
